export const CampaignNegativeWebpage = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Campaign Negative Webpage',
    },
    CampaignName: {
      'bulk-upload-header': 'Campaign',
    },
  },
};
